








































import "./member-list.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import UserAvatar from "../../components/common/user-avatar.vue";
import MemberSetup from "./member-setup.vue";
import InviteModal from "./invite.vue";

export default Vue.extend({
  name: "member-list",
  components: {
    UserAvatar,
    MemberSetup,
    InviteModal,
  },
  data() {
    return {
      showMemberSetup: false,
      showInvite: false,
      setupMember: null,
    };
  },
  computed: {
    ...mapState("review", ["loading", "currentReview"]),
    ...mapState("billing", ["billingAccount"]),
    ...mapGetters("review", ["canInviteMemberInCurrentReview"]),
    allMembers() {
      let context = this as any;
      let review = context.$store.state.review.currentReview;
      let members = review && review.members ? review.members : [];
      if (members === null) {
        members = [];
      }

      return members.map((member, index) => {
        let result = context.allAdminMembers.filter((accountMember) => accountMember.memberId === member.memberId);
        return {
          adminFlag: result.length === 1 ? (result[0].role === 1 ? "A" : "L") : "",
          memberId: member.memberId,
          memberName: member.memberName,
          memberEmailAddress: member.memberEmailAddress,
          memberPhoneNumber: member.memberPhoneNumber,
          memberAvatarImageUrl: member.memberAvatarImageUrl,
          role: member.role,
        };
      });
    },
    allAdminMembers() {
      let context = this as any;
      let members = context.billingAccount ? context.billingAccount.members : [];
      return members
        .filter((member) => member.role === 1 || member.role === 2)
        .map((member) => {
          return {
            isAdminOnly: true,
            adminFlag: member.role === 1 ? "A" : "L",
            memberAvatarImageUrl: member.memberAvatarImageUrl,
            memberEmailAddress: member.memberEmailAddress,
            memberId: member.memberId,
            memberName: member.memberName,
            role: member.role,
          };
        });
    },
    membersToShow() {
      return (this as any).allMembers.slice(0, 3);
    },
  },
  methods: {
    handleMemberClick(member) {
      this.showMemberSetup = true;
      this.setupMember = member;
    },
    handleInviteClick() {
      this.showInvite = true;
    },
  },
});
